(function () {
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.viewport = this.querySelector('[role="document"]');
      this.toolbar = this.querySelector('[data-media-controls]');
      this.scale = 1;
      this.onBack = () => { if (this.hasAttribute('open')) this.hide(true); };
      if (!this.toolbar) return;
      this.toolbar.addEventListener('click', (event) => {
        const action = event.target.closest('[data-media-action]')?.dataset.mediaAction;
        if (action === 'in') this.zoom(this.scale + 0.5);
        if (action === 'out') this.zoom(this.scale - 0.5);
        if (action === 'fit') this.zoom(1);
        if (action === 'next') this.changeMedia(1);
        if (action === 'previous') this.changeMedia(-1);
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || event.ctrlKey || event.metaKey || event.altKey || event.target.closest('deferred-media, product-model, input, textarea, select')) return;
        const actions = { '+': () => this.zoom(this.scale + 0.5), '=': () => this.zoom(this.scale + 0.5), '-': () => this.zoom(this.scale - 0.5), '0': () => this.zoom(1), ArrowRight: () => this.changeMedia(1), ArrowLeft: () => this.changeMedia(-1) };
        if (actions[event.key]) { event.preventDefault(); actions[event.key](); }
      });
      this.viewport.addEventListener('load', (event) => {
        if (event.target === this.activeMedia && this.hasAttribute('open')) this.layout();
      }, true);
      this.viewport.addEventListener('dragstart', (event) => { if (event.target.tagName === 'IMG') event.preventDefault(); });
      this.viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.scale <= 1 || this.activeMedia?.tagName !== 'IMG') return;
        event.preventDefault();
        this.drag = { x: event.clientX, y: event.clientY, left: this.viewport.scrollLeft, top: this.viewport.scrollTop };
        this.viewport.setPointerCapture(event.pointerId);
        this.viewport.classList.add('is-panning');
      });
      this.viewport.addEventListener('pointermove', (event) => {
        if (!this.drag) return;
        this.viewport.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        this.viewport.scrollTop = this.drag.top + this.drag.y - event.clientY;
      });
      for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) this.viewport.addEventListener(type, () => {
        this.drag = null;
        this.viewport.classList.remove('is-panning');
      });
      this.resizeObserver = new ResizeObserver(() => { if (this.hasAttribute('open')) this.layout(); });
      this.resizeObserver.observe(this.viewport);
    }
    show(opener) {
      super.show(opener);
      this.items = [...this.viewport.children].filter((item) => item.hasAttribute('data-media-id'));
      this.index = Math.max(0, this.items.findIndex((item) => item.dataset.mediaId === opener.dataset.mediaId));
      this.showActiveMedia();
      if (!this.toolbar) return;
      window.addEventListener('popstate', this.onBack);
      history.pushState({ ...history.state, iccProductMedia: this.id }, '', location.href);
    }
    hide(fromBack = false) {
      if (!this.hasAttribute('open')) return;
      window.removeEventListener('popstate', this.onBack);
      if (this.toolbar && fromBack !== true && history.state?.iccProductMedia === this.id) history.back();
      this.drag = null;
      this.scale = 1;
      super.hide();
      if (this.viewport) this.viewport.scrollTo(0, 0);
    }
    changeMedia(step) {
      if (this.items.length < 2) return;
      this.index = (this.index + step + this.items.length) % this.items.length;
      this.showActiveMedia();
    }
    showActiveMedia() {
      window.pauseAllMedia();
      this.activeMedia = this.items[this.index];
      if (!this.activeMedia) return;
      this.items.forEach((item) => item.classList.toggle('active', item === this.activeMedia));
      if (!this.toolbar) { this.activeMedia.scrollIntoView(); return; }
      this.scale = 1;
      this.drag = null;
      this.layout();
      this.viewport.scrollTo(0, 0);
      const template = this.activeMedia.querySelector('template');
      if (this.activeMedia.tagName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) this.activeMedia.loadContent();
    }
    zoom(scale) {
      if (this.activeMedia?.tagName !== 'IMG') return;
      const oldWidth = this.activeMedia.getBoundingClientRect().width;
      const oldHeight = this.activeMedia.getBoundingClientRect().height;
      const x = (this.viewport.scrollLeft + this.viewport.clientWidth / 2 - this.activeMedia.offsetLeft) / oldWidth;
      const y = (this.viewport.scrollTop + this.viewport.clientHeight / 2 - this.activeMedia.offsetTop) / oldHeight;
      this.scale = Math.min(4, Math.max(1, scale));
      this.layout();
      if (this.scale === 1) this.viewport.scrollTo(0, 0);
      else this.viewport.scrollTo(this.activeMedia.offsetLeft + x * this.activeMedia.width - this.viewport.clientWidth / 2, this.activeMedia.offsetTop + y * this.activeMedia.height - this.viewport.clientHeight / 2);
    }
    layout() {
      const image = this.activeMedia;
      if (!image || !this.toolbar) return;
      const isImage = image.tagName === 'IMG';
      if (isImage) {
        const ratio = (image.naturalWidth || Number(image.getAttribute('width'))) / (image.naturalHeight || Number(image.getAttribute('height')));
        const fitWidth = Math.max(1, Math.min(this.viewport.clientWidth - 24, (this.viewport.clientHeight - 24) * ratio));
        const width = fitWidth * this.scale;
        image.style.width = `${width}px`;
        image.style.height = `${width / ratio}px`;
        image.style.marginTop = `${Math.max(12, (this.viewport.clientHeight - width / ratio) / 2)}px`;
        image.sizes = `${Math.ceil(width)}px`;
      }
      this.viewport.classList.toggle('is-zoomed', isImage && this.scale > 1);
      this.toolbar.querySelector('[data-media-action="in"]').disabled = !isImage || this.scale >= 4;
      this.toolbar.querySelector('[data-media-action="out"]').disabled = !isImage || this.scale <= 1;
      this.toolbar.querySelector('[data-media-action="fit"]').disabled = !isImage;
      for (const action of ['next', 'previous']) this.toolbar.querySelector(`[data-media-action="${action}"]`).disabled = this.items.length < 2;
      this.toolbar.querySelector('[data-media-status]').textContent = `${this.index + 1} / ${this.items.length}${isImage ? ` · ${Math.round(this.scale * 100)}%` : ''}`;
    }
  });
}
})();
